import * as helper from './helper';
import { translate } from '../../../../helper/translate';

function init(job) {
    var pixConfig = {
        ui: {
            nav: {
                replaceDefault: true,
                items: [{ name: 'crop', icon: 'crop-custom', action: 'crop' }],
            },
        },
        onLoad: function () {
            customCropSetup();

            pixie.openPanel('crop');

            // give the editor time to render ui changes
            setTimeout(function () {
                /**
                 * workaround for an issue where event listeners defined in the
                 * vendor prevent the click event from reaching jquery event listeners
                 *
                 * for some reason this only happens when a tool was opened using pixie.openPanel()
                 */
                var $applyButton = $('button.apply-button').clone();
                $('button.apply-button').remove();
                $applyButton.appendTo('.tool-panel-container');

                addCustomCropButton();
            }, 100);

            $(document).on('click', 'button.apply-button', function () {
                pixie.applyChanges();
                window.pixApplied = true;

                setTimeout(function () {
                    pixie.openPanel('crop');

                    // give the editor time to render ui changes
                    setTimeout(addCustomCropButton, 100);
                }, 200);
            });

            helper.hideLoadingAnimation();
        },
    };

    function waitForPixie() {
        if (typeof Pixie === 'undefined') {
            setTimeout(waitForPixie, 500);

            return;
        }

        helper.initPixie(job, pixConfig);
    }

    waitForPixie();
}

function addCustomCropButton() {
    var $cropBtn = $('<button class="btn btn-default my-auto font-lg crop-custom text-capitalize">Custom</button>');

    $cropBtn.html(translate('Custom'));
    $cropBtn.appendTo('crop-drawer .aspect-ratios');
}

function customCropSetup() {
    $(document).on('click', 'crop-drawer .crop-custom', function () {
        document.getElementById('height').dispatchEvent(new Event('input'));
        $('.aspect-ratio').removeClass('selected');
    });

    $(document).on('click', '.aspect-ratio', function () {
        $('.aspect-ratio').removeClass('selected');
        $(this).addClass('selected');
    });

    $(document).on('click', 'button.control-button, button.apply-button', function () {
        // give the editor time to render ui changes
        setTimeout(function () {
            if ($('crop-drawer').length === 1 && $('.crop-custom').length === 0) {
                addCustomCropButton();
            }
        }, 100);
    });
}

export { init };
export { customCropSetup };
